import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/auth-store'
import { AuthenticatedLayout } from '@/components/layout/authenticated-layout'

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: ({ location }) => {
    const { auth } = useAuthStore.getState()
    const isAuth = auth.isAuthenticated()

    if (!isAuth) {
      throw redirect({
        to: '/sign-in',
        search: {
          redirect: location.href,
        },
      })
    }

    // Check if user is staff type
    if (auth.user?.type !== 'STAFF') {
      throw redirect({
        to: '/unauthorized',
      })
    }
  },
  component: AuthenticatedLayout,
})
